
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { IconBill } from '@ds/icons/IconBill'
import { mapGetters } from 'vuex'

export default {
  components: {
    IconBill,
    RevLink,
    RevModal,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      breakpoint: 'breakpoint',
    }),

    variant() {
      return this.breakpoint > 1 ? 'panel' : 'confirmation'
    },
  },
}
